import React from "react";
import ReusableTitle from "../ui/ReusableTitle";

export default function SubmissionTitle() {
  return (
    <ReusableTitle
      text1="SERVICE"
      text2="DEPARTMENT"
      text3="DATE/TIME"
      text4="STATUS"
      text5="DESIGNATION"
    />
  );
}
